import { FullScreenLoading } from '@backrs_ui/common-ui';

import { appStrings } from '@backrs_ui/grow-ui/src/assets/appStrings';
import {
  useGetAwardLetterQuery,
  useGetUserCollegesQuery,
} from '@backrs_ui/grow-ui/src/redux/userColleges/userColleges.api';

import { Typography } from '@mui/material';

import { AwardLetterPage } from './AwardLetterPage';

const STRINGS = appStrings.modules.myColleges.awardLetter;

export const AwardLetter = ({ userCollegeId }: Readonly<{ userCollegeId: number }>) => {
  const colleges = useGetUserCollegesQuery(undefined);
  const college = colleges.data?.colleges.find((candidate) => candidate.id === userCollegeId);
  const letter = useGetAwardLetterQuery(userCollegeId, { skip: !college });

  if (colleges.data && !college) {
    return <Typography variant="text-md-regular">{STRINGS.notOnList}</Typography>;
  }

  if (colleges.isError || letter.isError) {
    return <Typography variant="text-md-regular">{STRINGS.loadFailed}</Typography>;
  }

  if (!college || !letter.data || letter.isFetching) {
    return <FullScreenLoading />;
  }

  return <AwardLetterPage key={college.id} college={college} letter={letter.data} />;
};
